


































































































import { Component } from 'vue-property-decorator';
import { HeaderList, List } from '@/components/Table/TableModel';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import basePagination from '@/components/BasePagination/BasePagination.vue';
import ShareOfferTooltip from '@/components/ShareOfferTooltip/ShareOfferTooltip.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import EmptyState from '@/components/organisms/Offers/EmptyState.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import ContextMenu from '@/components/ContextMenu/ContextMenu.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import SpecialCoinOffersService from '@/api/SpecialCoinOffersService';
import eventBus from '@/utils/eventBus';
import {
  CustomSelectGroup,
  CustomSelectModel,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import DateUtils from '@/utils/DateUtils';
import DateFilter from '@/components/molecules/DateFilter/DateFilter.vue';
import { IPeriod } from '@/models/period';
import PerformanceUtils from '@/utils/PerformanceUtils';
import TextField from '@/componentsV2/molecules/Inputs/TextField.vue';
import FilterByTags from '@/componentsV2/organisms/FilterByTags/FilterByTags.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import ShareIcon from '@/components/icons/Share.vue';
import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import { getRenewedValue, EOfferRulesName } from '@/models/offer';
import OfferItem from '@/components/organisms/Offers/DataPresentation/OfferItem.vue';
import ListOfferOverview from '@/components/organisms/Offers/DataPresentation/ListOfferOverview.vue';
import { FilledButton } from '@/components/molecules';
import PlusIcon from '@/components/icons/Plus.vue';
import CompleteOfferWithImages from '@/components/organisms/Offers/DataPresentation/CompleteOfferWithImages.vue';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    FlexButton,
    TextField,
    ShareOfferTooltip,
    Page,
    EmptyState,
    CustomSelect,
    ContextMenu,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    DateFilter,
    FilterByTags,
    Typography,
    SectionData,
    ShareIcon,
    FilterTag,
    OfferItem,
    PlusIcon,
    FilledButton,
    ListOfferOverview,
    CompleteOfferWithImages
  }
})
export default class Offer extends basePagination {
  offers: List = new List([], []);
  service = new SpecialCoinOffersService();
  searchableFields = 'searchableFields=offer.title';
  sortField = this.useOfferListV2 ? 'priorizeInactive' : 'createdAt';
  sortOrder = 'DESC';
  activeTooltip = '';
  listEmpty: boolean = true;
  period: IPeriod = PerformanceUtils.defaultPeriod();
  tags = [
    {
      label: 'Storewide deal',
      type: 'storewide-deal',
      specialType: 'Storewide'
    },
    {
      label: 'Specific product / service',
      type: 'specific-product',
      specialType: 'ProductAndService'
    },
    { label: 'Birthday offer', type: 'birthday-offer', specialType: 'Birthday' }
  ];
  filtersList: Record<string, any> = {
    ...PerformanceUtils.defaultPeriodForFilter()
  };
  targetClassForInfineScroll = '.container-scrollable';
  endpointPath = '';
  performanceOverview = {
    totalMembersInteracted: 0,
    totalRedeems: 0,
    totalActive: 0,
    totalSaved: 0,
    totalImpressions: 0
  };
  cachedFiltersReloading = false;
  forceReloadList = false;

  constructor() {
    super();
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get configSection() {
    return {
      padding: this.isMobileDevice ? '32px 0 0 0' : '24px 0 0 0',
      borderRadius: this.isMobileDevice ? '0 0 16px 16px' : '16px',
      background: 'transparent'
    };
  }

  get tPrefix() {
    return `offers`;
  }

  get text() {
    return `Create new ${this.$t(`${this.tPrefix}.title.singular`)}`;
  }

  get title() {
    return this.$t(`${this.tPrefix}.title.plural`);
  }

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get cachedFilters() {
    return this.$store.getters['offerList/getOfferListConfigState'].filters;
  }

  get useOfferListV2() {
    return this.getFlags.includes(flagKeys.dashboardOffersListV2);
  }

  get keyOrder() {
    const defaultKeyOrder = [
      'picture',
      'title',
      'created',
      'status',
      'total_opens',
      'saved',
      'redeemed'
    ];

    if (this.verifyFlag('referral-offer')) {
      defaultKeyOrder.push('slot:share-button');
    }

    defaultKeyOrder.push('slot:options');

    return defaultKeyOrder;
  }

  get prevRouteIsOfferDetail() {
    return (
      window.previousRouteName && window.previousRouteName === 'offer-detail'
    );
  }

  get educationVideo() {
    let align = 'right';
    if (this.listEmpty && this.$mobileCheck()) align = 'center';
    // it doesn't exist a video yet.
    return false;
    // return {
    //   sectionName: this.$t(`${this.tPrefix}.title.plural`),
    //   link: 'https://www.youtube.com/watch?v=LBQwiCpZouk',
    //   align
    // };
  }

  get inactiveOffers() {
    return this.offers.list.filter(offer => !offer.image);
  }

  async loadPerfomanceOverview() {
    this.$showLoaderWithLocker();

    try {
      const response = await this.service.getOffersOverview();
      this.performanceOverview = response.data;
      this.$hideLoader();
    } catch (error) {
      this.$hideLoader();
    }
  }

  created() {
    this.handleInitialFilter();
    this.loadPerfomanceOverview();

    eventBus.$on('reloadOfferList', this.reloadList);
  }

  mounted() {
    if (this.$route.query.modal === 'open') {
      if (this.$store.getters['business/getBusinessInfo'].business) {
        this.addNewOffer();
      } else {
        this.$showLoaderWithLocker();
        eventBus.$on('setBusinessInfo', () => {
          this.$hideLoader();
          this.addNewOffer();
        });
      }
    }
    if (this.$mobileCheck()) {
      const fromIndex = 1;
      const toIndex = 0;

      const element = this.tags.splice(fromIndex, 1)[0];

      this.tags.splice(toIndex, 0, element);
    }
  }

  handleInitialFilter() {
    if (!this.prevRouteIsOfferDetail) return;
    this.forceReloadList = true;
    this.cachedFiltersReloading = true;
    const {
      period = {},
      search = '',
      selectedOptions = []
    } = this.cachedFilters;
    // if (search) this.handleSearchChange(search);
    this.search = search;
    this.handlePeriodChange(period || this.period, false);
    setTimeout(() => {
      this.handleFilterChange(selectedOptions);
    }, 300);
  }

  getTagItem(item: any) {
    return (
      this.tags.filter(
        element => element.specialType === item.specialType
      )[0] || {}
    );
  }

  handlePeriodChange(period: IPeriod, reloadList: boolean = true) {
    if (!period.start && !period.end) return;

    this.handleCachedFilterChange({ period });
    this.period = PerformanceUtils.normalizedPeriod(period);
    this.handleFilter({
      from: this.period.start,
      to: this.period.end
    });

    const formatDate = (date: string) =>
      DateUtils.formattedDate({
        date,
        applyTimezone: true
      });

    this.$analytics({
      eventAction: 'change',
      eventCategory: 'Special Coin Offers - Period',
      eventLabel: `${formatDate(period.start)} - ${formatDate(period.end)}`
    });
    if (reloadList) this.reloadList(true);
  }

  handleTagFilterChange(selectedOptions: string[]) {
    const specialTypes = this.tags
      .filter(
        item => item.type === selectedOptions.filter(b => b === item.type)[0]
      )
      .map(a => a.specialType);

    this.handleFilter({ specialType: specialTypes.join(',') });
    this.endpointPath = '';
    this.reloadList(true);
  }

  handleFilter(filters: any) {
    this.filtersList = {
      ...this.filtersList,
      ...filters
    };
  }

  handleSearchChange(event: any) {
    this.handleCachedFilterChange({
      search: event
    });
    this.filterBySearch(event, 'Special Coin Offers menu first page | Search');
  }

  handleFilterChange(selectedOptions: CustomSelectOption[]) {
    if (selectedOptions.length) {
      this.$analytics({
        eventCategory: 'Special Coin Offers menu first page | Filter',
        eventAction: 'change',
        eventLabel: `Filtered by status: ${selectedOptions
          .map(option => option.label)
          .join(', ')}`
      });
    }

    this.handleCachedFilterChange({
      selectedOptions
    });
    this.filterByStatus(selectedOptions);
  }

  handleCachedFilterChange(filters: any) {
    this.$store.dispatch('offerList/SET_CONFIG', {
      config: {
        filters: {
          ...this.cachedFilters,
          ...filters
        }
      }
    });
  }

  mayOpenDetailsAccordingToQuery() {
    const { details } = this.$route.query;
    if (details) {
      const offer = this.offers.list.find(offer => offer.id === details);
      this.$router.replace({ query: {} });

      if (offer) {
        this.detail(offer);
      }
    }
  }

  closeTooltip() {
    this.activeTooltip = '';
  }

  toggleTooltip(id: string, event: MouseEvent) {
    event.stopPropagation();
    if (this.activeTooltip) this.activeTooltip = '';
    else this.activeTooltip = id;
  }

  beforeDestroy() {
    eventBus.$off('reloadOfferList', this.reloadList);
  }

  reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string,
    callback?: (items: any) => void
  ) {
    if (clearList) {
      this.resetPagination();
      this.offers.list = [];
      this.maxItems = false;
      this.endpointPath = '';
    }
    // if (this.refreshing || this.maxItems) return;
    if (!this.forceReloadList && (this.refreshing || this.maxItems)) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    this.service
      .getOffers(
        this.sortField,
        this.sortOrder,
        this.pagination,
        this.query,
        this.filtersList,
        this.endpointPath,
        this.useOfferListV2
      )
      .then(response => {
        const { data } = response;
        const { items, links } = data;

        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.endpointPath = `/${links.next}`;
          if (!links.next) {
            this.maxItems = true;
            this.endpointPath = '';
          }
          this.offers.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.offers.list = this.offers.list.concat(this.addRowsToList(items));
          this.endpointPath = `/${links.next}`;
          if (!links.next) {
            this.maxItems = true;
            this.endpointPath = '';
          }
          if (this.listEmpty) this.listEmpty = !this.offers.list.length;
        }

        if (clearList) this.mayOpenDetailsAccordingToQuery();
        if (callback) callback(items);
      })
      .catch(() => {})
      .finally(() => {
        this.$hideLoader();
        this.refreshing = false;
        this.isLoading = true;
        this.forceReloadList = false;
        this.cachedFiltersReloading = false;
      });
  }

  addRowsToList(offerRows: any[]): any[] {
    let rows: any[] = [];
    offerRows.forEach((offerRow: any) => {
      const createdAtDate = DateUtils.formattedDate({
        date: offerRow.createdAt,
        applyTimezone: true
      });
      const createdAtHour = DateUtils.formattedDate({
        date: offerRow.createdAt,
        format: 'h:mm a',
        applyTimezone: true
      });

      const createdAt = this.isMobileDevice
        ? `${createdAtDate} • ${createdAtHour}`
        : `${createdAtDate}<br />${createdAtHour}`;

      rows.push({
        ...offerRow,
        id: offerRow.id,
        picture: offerRow.image ? offerRow.image.publicPath.small : '',
        title: offerRow.title,
        type: this.helper.capitalize(offerRow.type),
        specialType: this.helper.capitalize(offerRow.specialType),
        redeemed: this.getRelationByMaxRedeemed(offerRow, 'redeemsCounter'),
        discount: offerRow.discount,
        description: offerRow.description,
        created: createdAt,
        expirationDate:
          offerRow.expirationDate &&
          DateUtils.formattedDate({
            date: offerRow.expirationDate,
            applyTimezone: true
          }),
        total_opens: offerRow.viewsCounter,
        saved: this.getRelationByMaxRedeemed(offerRow, 'savedCounter'),
        rules: offerRow.rules,
        method: offerRow.method,
        branchLink: offerRow.branchLink,
        business: offerRow.business,
        renewed: this.getRenewedLabel(
          offerRow.rules.filter(
            (rule: any) => rule.name === EOfferRulesName.RENEWED_RULE
          )[0]
        ),
        nonMembersReached: offerRow.nonMembersReached
      });
    });
    return rows;
  }

  getRenewedLabel(rule: any) {
    if (!rule) return '-';

    const data = getRenewedValue(rule.value);
    return `Every${Number(data.time) === 1 ? '' : ` ${data.time}`} ${
      data.periodFormatted
    }`;
  }

  getRelationByMaxRedeemed(row: any, nameParam: string) {
    const rule = row.rules.filter(
      (item: any) => item.name === 'max_redeemed_items'
    );
    if (rule.length) return `${row[nameParam]}/${rule[0].value}`;

    return `${row[nameParam]}/No limit`;
  }

  detail(data: any) {
    this.$router.push(`/special-coins-offers/${data.id}`);
  }

  initHeader() {
    const header: HeaderList[] = [
      new HeaderList(`Date`, 'createdAt', '12px 12px 12px 32px'),
      new HeaderList(`Title`, 'title', '12px 32px 12px 12px'),
      new HeaderList(`Renew period`, '', '12px'),
      new HeaderList(`Saved`, 'savedCounter', '12px'),
      new HeaderList(`Redeemed`, 'redeemsCounter', '12px'),
      new HeaderList(
        `${this.$t(`${this.tPrefix}.title.singular`)} Type`,
        'type',
        '12px'
      ),
      new HeaderList('', 'none'),
      new HeaderList('', 'none', '12px')
    ];
    this.offers.header = header;
  }

  initFilterModel() {
    const options = [
      {
        value: 'active',
        label: 'Active'
      },
      {
        value: 'expired',
        label: 'Expired'
      },
      {
        value: 'archived',
        label: 'Archived'
      }
    ];
    const { selectedOptions = [] } = this.cachedFilters;
    const actionGroup = new CustomSelectGroup(
      options.map(
        option =>
          new CustomSelectOption(
            option.value,
            option.label,
            this.prevRouteIsOfferDetail &&
              selectedOptions.some(
                (selectedOption: any) => selectedOption.uuid === option.value
              )
          )
      )
    );

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `Select a status`,
      false,
      true,
      true,
      true
    );
  }

  addNewOffer({ isEmptyState = false } = {}) {
    this.$analytics({
      eventCategory: `Special Coin Offer menu first page | Create new offer button${
        isEmptyState ? ' | Empty State' : ''
      }`,
      eventAction: 'click',
      eventLabel: 'Clicked on the "Create new offer" button'
    });
    this.$router.push('/special-coins-offers/create');
  }
}
